export default __webpack_public_path__ + "static/media/paper.5b5a30b5.svg";